// ProgressCard
// Renders the "Progress by Developer" card showing how many questions
// each developer has submitted for the currently selected entity.
// All state is owned by ConsoleTraining.tsx and passed in as props.

import React from 'react';
import { TrainingProgressItem } from '../../../types';

interface ProgressCardProps {
  progress: TrainingProgressItem[];
}

const ProgressCard: React.FC<ProgressCardProps> = ({ progress }) => {
  return (
    <div className="console-card">
      <h2>Progress by Developer</h2>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>User</th>
              <th>Questions</th>
            </tr>
          </thead>
          <tbody>
            {progress.map((row) => (
              <tr key={row.user_email}>
                <td>{row.user_email}</td>
                <td>{row.submitted_questions}/30</td>
              </tr>
            ))}
            {!progress.length ? (
              <tr>
                <td colSpan={2}>No questions submitted yet for this entity.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProgressCard;